import { render, staticRenderFns } from "./AreaDrawing.vue?vue&type=template&id=671e9200&"
import script from "./AreaDrawing.vue?vue&type=script&lang=js&"
export * from "./AreaDrawing.vue?vue&type=script&lang=js&"
import style0 from "./AreaDrawing.vue?vue&type=style&index=0&id=671e9200&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports